var exports = {
  "L8": "CopilotIndicatorContainer__hKO3gD",
  "ZZ": "CopilotSpinnerContainer__rCagYh",
  "Xv": "CopilotWaitingText__F6QDGr",
  "l0": "CopilotIconContainer__g6rGP6",
  "in": "CopilotIconContainerDefault__aKRrMH",
  "PP": "CopilotIconContainerError__sr-n-4",
  "_N": "CopilotErrorBadge__sCtNUx",
};

module.exports = exports;
